
import CryptoJS from 'crypto-js';
import { ElMessageBox } from 'element-plus'
import router from '@/router/index'
import { decryptSm4CbcWithToken } from './sm4Util'
// CryptoJS加密
function generateSignature(params) {
  let secretKey = 'BwkLGbyfTiyij3QG9si5FCozqeC4FaK5hDvPsIANpkM02zjBn1z3+svtISsDbPHV0d4KxCKzzySAwLdQA3PuDA=='
  let sortedKeys = Object.keys(params)
  let paramStr = '';
  sortedKeys.forEach((key) => {
    paramStr += `${key}=${params[key]}`;
  });
  let signStr = paramStr + secretKey;
  let hash = CryptoJS.SHA512(signStr);
  let hexString = hash.toString(CryptoJS.enc.Hex);
  return hexString;
}
// 排序
function dataSort(obj) {
  let sortedKeys = Object.keys(obj).sort();
  let sortedObj = {};
  sortedKeys.forEach(key => {
    if (obj[key] !== null && obj[key] !== undefined) {
      sortedObj[key] = obj[key];
    }
  });
  return sortedObj
}
// AES加密
function encrypt(plainText) {
  const key = `Bk0e+K9Ddbr5hc1N3Yhg+g==`
  const decodedKey = CryptoJS.enc.Base64.parse(key); // Base64 解码密钥
  const src = CryptoJS.enc.Utf8.parse(plainText);
  const encrypted = CryptoJS.AES.encrypt(src, decodedKey, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  });
  // 输出base64字符串
  return encrypted.toString();
}
// AES解密
function aesDecrypt(encryptedText) {
  if (!encryptedText) {
    return encryptedText
  }
  let key = `Bk0e+K9Ddbr5hc1N3Yhg+g==`
  try {
    const decodedKey = CryptoJS.enc.Base64.parse(key); // Base64 解码密钥
    const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText); // Base64 解码加密数据
    const decrypted = CryptoJS.AES.decrypt( // 解密
      { ciphertext: encryptedBytes }, // 加密数据
      decodedKey, // 密钥
      {
        mode: CryptoJS.mode.ECB, // 加密模式（根据 Java 代码的 TRANSFORMATION 设置）
        padding: CryptoJS.pad.Pkcs7 // 填充模式
      }
    );
    let encryResult = decrypted.toString(CryptoJS.enc.Utf8)// 将解密结果转换为 UTF-8 字符串
    return encryResult ? decrypted.toString(CryptoJS.enc.Utf8) : encryptedText
  } catch (error) {
    return encryptedText
  }
}

// 请求结果错误处理
function responseHandleError(error) {
  if (error.response) {
    switch (error.response.status) {
      case 406:
        ElMessageBox.confirm('登录信息已失效，请重新登录')
          .then(() => {
            router.push('/login')
            history.go(0)
          })
          .catch(() => {
            router.push('/login')
            history.go(0)
          })
        break
      case 401:
        ElMessageBox.confirm('登录信息已失效，请重新登录')
          .then(() => {
            router.push('/login')
            history.go(0)
          })
          .catch(() => {
            router.push('/login')
            history.go(0)
          })
        break
    }
  }
}
function sm4Decrypt(cipherBase64, resHeaders, httpType) {
  let token = ''
  let salt = ''
  if (httpType === 'open') {//开放接口从请求头获取
    token = resHeaders['x-sm4'] || resHeaders['X-SM4']
    salt = resHeaders['x-sm4-salt'] || resHeaders['X-SM4-SALT']
  } else {
    token = sessionStorage.getItem('token')
    salt = sessionStorage.getItem('salt')
  }
  let ivBase64 = resHeaders['x-sm4-iv'] || resHeaders['X-SM4-IV']
  let xSm4Kdf = resHeaders['x-sm4-kdf'] || resHeaders['X-SM4-KFD']
  const result = decryptSm4CbcWithToken(cipherBase64, ivBase64, token, salt, xSm4Kdf);
  return result
}
// 请求结果处理
function responseHandle(response, httpType) {
  if (response.status === 200) {
    if (response.data.data) {
      response.data = sm4Decrypt(response.data.data, response.headers, httpType)
    }
  }
  return response
}


export { responseHandle, generateSignature, dataSort, responseHandleError, aesDecrypt, encrypt }